import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Zap } from "lucide-react";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then(r => setCats(r.data || [])); }, []);
  return (
    <div data-testid="categories-page" className="pt-28 pb-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-xs uppercase tracking-[0.25em] text-zinc-500">Explore</p>
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-2 mb-10">Categories</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {cats.map((c) => (
          <Link key={c.slug} to={`/browse?category=${c.slug}`} data-testid={`cat-link-${c.slug}`} className="card-surface p-8">
            <Zap className="w-5 h-5 text-[#FF007F] mb-8" />
            <p className="font-display font-bold text-2xl">{c.name}</p>
            <p className="text-xs uppercase tracking-widest text-zinc-500 mt-2">Browse →</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
